import React from 'react';
import styles from './Loading.module.css';

const LoadingSpinner = ({ size = 'medium', message = '' }) => {
  const sizeClass = styles[`spinner-${size}`];

  return (
    <div className={styles.container}>
      <div className={`${styles.spinner} ${sizeClass}`}></div>
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
